import script from "./ViewRecuperarPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewRecuperarPassword.vue?vue&type=script&setup=true&lang=js"

import "./ViewRecuperarPassword.vue?vue&type=style&index=0&id=74b19535&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74b19535"]])

export default __exports__